<script>
  export default {
    props: {
      url: { type: String, default: "" },
    },
    data() {
      return {
      }
    },
  }
</script>
<template>
  <div>
    <b-modal
      id="ModalViewPDF"
      title="PDF"
      size="xl"
      no-close-on-backdrop
      no-close-on-esc
    >  
      <template #default="{  }">
        <iframe :src="url" frameborder="0" style="height: 70vh; width: 100%"></iframe>
      </template>
    </b-modal>
  </div>
</template>